import AppLogo from "../../apps/logo"
import { classNames } from "../../../../lib/helpers"
import { numFormatter } from "../../../../lib/format"


export default function ComparisonTableHeader({ app={}, keyValue='header', primary=false, title='', count=0  }) {
  
  const className = classNames(primary ? 'bg-green-200' : 'bg-gray-200', 'flex my-3 px-2 py-1.5 sm:py-2 rounded border border-gray-200 gap-x-2')

  return (
    <div key={keyValue} className={className}>
      <div className="flex-shrink-0" >
        <AppLogo app={app} className="w-6 h-6 rounde-sm text-sm sm:text-base text-white"/>
      </div>
      <p className="text-sm sm:text-base text-gray-700 leading-6 font-bold  w-full truncate">
        <span className="hidden sm:inline">{title}</span>
        <span className="sm:hidden">Total</span>
      </p>
      <div className="flex-shrink-0" >
        <span className="font-bold text-sm sm:text-base">
          {numFormatter(count)}
        </span>
      </div>
    </div> 
  )
}
